var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"z-caption",class:_vm.classObject},[_vm._t("default"),(_vm.withArrow)?_c('z-icon',{attrs:{"name":"btn-arrow-2","width":"16","height":"16"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }